'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'arrows-repeat-1';
var width = 512;
var height = 512;
var aliases = ["repeat-1-alt"];
var unicode = 'f366';
var svgPathData = 'M473 79c9.4 9.4 9.4 24.6 0 33.9l-88 88c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-206.1 0c-79.5 0-144 64.5-144 144 0 13.3-10.7 24-24 24S0 277.3 0 264C0 158 86 72 192 72l206.1 0-47-47c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l88 88zM32 416c0-6.4 2.5-12.5 7-17l88-88c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 206.1 0c79.5 0 144-64.5 144-144 0-13.3 10.7-24 24-24s24 10.7 24 24c0 106-86 192-192 192l-206.1 0 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L39 433c-4.5-4.5-7-10.6-7-17zM288 216l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c-10 0-19.4-6.4-22.8-16.4-4.2-12.6 2.6-26.2 15.2-30.4l24-8c7.3-2.4 15.4-1.2 21.6 3.3s10 11.8 10 19.5z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faArrowsRepeat1 = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;